import { route as ziggyRoute } from '../../vendor/tightenco/ziggy/src/js/index.js';

export const route = (name, params, absolute = false, config) => {
    return ziggyRoute(name, params, absolute, config);
};
